'use client';

import {
  Box,
  Flex,
  Text,
  Button,
  useBreakpointValue,
  Grid,
  Avatar,
  VStack,
  Image,
  SkeletonText,
  Modal,
  ModalContent,
} from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { useEffect, useMemo, useState, useRef } from 'react';
import { fetchCategoryCards } from '../../services/yogaService';
import GetProgramFeatureList from './GetProgramFeatureList';
import { useSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { mixPanel } from '@utils/Mixpanel';
import { render } from 'datocms-structured-text-to-html-string';
import StructuredTextParser from '../../app/landing_pages/karma/Components/StructuredTextParser';
import { useRegisterPopupVisibilityContext } from '@landing_pages/margazhi/context/registerPopupVisibilityContext';

const durations = [3, 5, 7, 14, 21];

const totalStep = [1, 2, 3];

export default function RegisterPopup({
  isOpen,
  sectionContent,
  onClose,
  pageData,
  isMounted,
  onOpen,
}) {
  const { isLargeScreen } = useRegisterPopupVisibilityContext();
  function getDataFromList(name) {
    return sectionContent?.find(a => a._modelApiKey === name);
  }

  const { sharedJson, pageConfig } = pageData || {};
  const { json } = sharedJson || {};
  const {
    duration: durationText,
    category: categoryText,
    amount,
  } = pageConfig || {};
  const { duration } = json || {};
  const router = useRouter();
  const searchParams = useSearchParams();
  const Mixpanel = mixPanel(router.asPath);
  const jsonData = getDataFromList('json_table');
  const testimonialData = getDataFromList('testimonials_group_v2');
  const {
    category,
    continue: continueText,
    duration: duration1Text,
    step1,
  } = jsonData?.data?.[0] || {};
  const {
    step2,
    selection: selection2Text,
    batch: batch2Text,
    continue: continue2Text,
  } = jsonData?.data?.[1] || {};
  const {
    batch: batch3Text,
    continue: continue3Text,
    selection: selection3Text,
    step3,
    year,
  } = jsonData?.data?.[2] || {};
  const [selectedDuration, setSelectedDuration] = useState(3);
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedDateObj, setSelectedDateObj] = useState({});
  const [eventApiRes, setEventApiRes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const scrollableContentRef = useRef(null);

  const categoriesList = duration?.[selectedDuration]?.categories || {};
  const currentSelectedDurationData = Object.keys(categoriesList) || {};
  const currentSelectedProgram = categoriesList[selectedCategory] || [];



  const mixPanelTrigger = () => {
    Mixpanel.track('margazhi_category_selected', {
      duration: selectedDuration,
      category: selectedCategory,
      amount: getPrice(currentSelectedProgram?.price, selectedCategory),
    });
  };

  const onCloseHandler = () => {
    onClose();
  };

  let ParentModal = useBreakpointValue({base: Modal, md: Box})
  let ParentModalContent = useBreakpointValue({base: ModalContent, md: Box})

  useEffect(() => {
    const mainDiv = document.getElementById('#containerWrapper');
    const footerDiv = document.getElementById('#isoNewFooter');

    if (!mainDiv || !footerDiv) return;
  
    let faqPopup = document.getElementById('faq-popup');
    const registerPopup = document.getElementById('register-popup');

    // Handle faq popup visibility
    if (isOpen) {
      if (faqPopup) {
        faqPopup.style.display = 'none';
      }
    } else if (faqPopup) {
      faqPopup.style.display = 'unset';
    }

    if(!isOpen && !registerPopup) return;

    // Remove previous keyframe style if exists
    const prevStyle = document.getElementById('dynamic-width-animation');
    if (prevStyle) prevStyle.remove();
    
    let mainDivOffsetW = mainDiv.offsetWidth + 'px'
    // Determine target width
    const currentWidth = faqPopup ? mainDivOffsetW : (isOpen && isLargeScreen ? mainDivOffsetW :  'calc(100vw - 410px)');
    const targetWidth = faqPopup ? `calc(100vw - 410px)` : (isOpen && isLargeScreen && !faqPopup ? `calc(100vw - 410px)` : mainDivOffsetW);

    // Create a keyframe dynamically for both slide right and left
    const style = document.createElement('style');
    style.id = 'dynamic-width-animation';
    style.innerHTML = `
      @keyframes widthAnim {
        from { width: ${currentWidth}; }
        to { width: ${targetWidth}; }
      }
    `;
    if ((isMounted || isOpen) && isLargeScreen) {
      document.head.appendChild(style);
      // Apply animation
      mainDiv.style.animation = 'widthAnim 0.5s ease forwards';
      footerDiv.style.animation = 'widthAnim 0.5s ease forwards';
    }
    
    // Handle scroll lock for small screens
    if (isOpen) {
      if (!isLargeScreen) {
        document.body.style.position = 'relative';
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.position = '';
        document.body.style.overflow = 'auto';
      }
      setTimeout(() => {
        if(isOpen && scrollableContentRef.current){
          scrollableContentRef.current.scrollTop = 0;
        }
      }, 100)
    } else {
      // Reset styles when popup is closed
      document.body.style.position = '';
      document.body.style.overflow = 'auto';
    }
    
  }, [isOpen, isLargeScreen, isMounted]);

  useEffect(() => {
    if(isOpen && scrollableContentRef.current){
      scrollableContentRef.current.scrollTop = 0;
    }
  }, [currentStep]);

  const slideIn = keyframes`
        from {
        transform: translateX(100%); /* start off-screen right */
        }
        to {
        transform: translateX(0); /* end at normal position */
        }
        `;

  const slideOut = keyframes`
        from {
        transform: translateX(0);
        }
        to {
        transform: translateX(100%);
        }`;
  const slideUp = keyframes`
    from {
    transform: translateY(100%); /* start off-screen right */
    }
    to {
    transform: translateY(0); /* end at normal position */
    }
    `;
  const slideDown = keyframes`
    from {
    transform: translateY(0); /* start off-screen right */
    }
    to {
    transform: translateY(100%); /* end at normal position */
    }
    `;
  const fadeIn = keyframes`
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  `;
  const fadeOut = keyframes`
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  `;

  const removeSpecialChars = (str = "") => {
    return str.replace(/[^a-zA-Z0-9]/g, '');
  };

  const eventHandler = async eventIds => {
    try {
      const response = await fetchCategoryCards(eventIds);
      const { result } = response;
      const data = {};
      if (result) {
        result.forEach(item => {
          item?.tickets?.forEach(ticket => {
            data[`${removeSpecialChars(ticket?.name)}`?.toLowerCase()] = ticket;
          });
        });
      }
      setEventApiRes(data);
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const eventData = [];
    const ids = [];
    if (!!Object.keys(duration || {})?.length) {
      Object.keys(duration).forEach(item => {
        if (!!Object.keys(duration[item]['categories'])?.length) {
          Object.keys(duration[item]['categories']).forEach(category => {
            if (
              !!Object.keys(duration[item]['categories'][category]['dates'])
                ?.length
            ) {
              duration[item]['categories'][category]['dates'].forEach(date => {
                eventData.push({
                  duration: item,
                  iprs: date?.iprs,
                  start: date?.start,
                  end: date?.end,
                  category: category,
                });
                if (!ids.includes(date?.iprs)) {
                  ids.push(date?.iprs);
                }
              });
            }
          });
        }
      });
    }
    if (!!ids?.length) {
      eventHandler(ids, eventData);
    }
  }, []);

  const getPrice = (price, cat) => {
    if (isLoading) {
      return <SkeletonText width={'100px'} lineHeight={'20px'} noOfLines={1} />;
    }
    const keyName = `${cat}${selectedDuration}days`?.toLowerCase();
    const findData = eventApiRes[keyName];

    if (findData?.price) {
      return `${findData?.price.toLocaleString('en-IN')} INR`;
    }
    return `${price.toLocaleString('en-IN')} INR`;
  };

  const onBackClick = () => {
    if (currentStep === 1) {
      onCloseHandler();
      return;
    }
    setCurrentStep(prev => prev - 1);
  };

  const isButtonDisabled = useMemo(() => {
    if (currentStep === 1) {
      return !selectedCategory?.length;
    } else if (currentStep === 2) {
      return !selectedDateObj?.start?.length;
    }
    return false;
  }, [currentStep, selectedCategory, selectedDateObj?.start]);

  const formatDateRange = (start, end, isShowInFullFormat = false) => {
    const startDate = new Date(start);
    const endDate = new Date(end);

    const startMonth = startDate.toLocaleString('en-US', { month: 'short' });
    const endMonth = endDate.toLocaleString('en-US', { month: 'short' });

    const startDay = startDate.getDate();
    const endDay = endDate.getDate();

    const options = { weekday: 'short', month: 'short', day: 'numeric' };

    const startStr = startDate.toLocaleDateString('en-US', options);
    const endStr = endDate.toLocaleDateString('en-US', options);

    const startYear = startDate.getFullYear();
    const endYear = endDate.getFullYear();
    if (isShowInFullFormat) {
      // if (startYear !== endYear) {
      //   // Different years → Dec 31, 2025 – Jan 4, 2026
      //   return `${startStr}, ${startYear} – ${endStr}, ${endYear}`;
      // } else {
      //   // Wed, Jan 7 – Fri, Jan 9
      //   return `${startStr} – ${endStr}`;
      // }
      return `${startStr} – ${endStr}`;
    }

    if (startYear !== endYear) {
      // Different years → Dec 31, 2025 – Jan 4, 2026
      return `${startMonth} ${startDay} – ${endMonth} ${endDay}`;
    } else if (startMonth === endMonth) {
      // Same month & year → Jan 7 – 9, 2026
      return `${startMonth} ${startDay} – ${endDay}`;
    } else {
      // Same year but different months → Dec 31 – Jan 4, 2026
      return `${startMonth} ${startDay} – ${endMonth} ${endDay}`;
    }
  };

  const onCatUpdate = (cat, price) => {
    setSelectedCategory(cat);
    setSelectedDateObj({});
  };

  const onRegisterClick = () => {
    Mixpanel.track('margazhi_continue_registration_cta_click', {
      duration: selectedDuration,
      batch: formatDateRange(
        selectedDateObj?.start,
        selectedDateObj?.end,
        true
      ),
      category: selectedCategory,
      amount: getPrice(currentSelectedProgram?.price, selectedCategory),
      cta: "bottom cta",
      element: 'CONTINUE TO REGISTER',
    });
    onCloseHandler();
  };

  const getData = cat => {
    const data = categoriesList[cat] || {};
    const price = getPrice(data.price, cat);
    return (
      <Box
        key={`${Date.now()}${cat}`}
        rounded="4px"
        cursor="pointer"
        border={
          selectedCategory === cat
            ? '1px solid #2F3E92'
            : '1px solid rgba(29, 26, 22, 0.10)'
        }
        onClick={() => !isLoading && onCatUpdate(cat, price)}
        boxShadow={
          '0 29px 8px 0 rgba(0, 0, 0, 0.00), 0 18px 7px 0 rgba(0, 0, 0, 0.00), 0 10px 6px 0 rgba(0, 0, 0, 0.01), 0 5px 5px 0 rgba(0, 0, 0, 0.02), 0 1px 3px 0 rgba(0, 0, 0, 0.02)'
        }
        _hover={{border: '1px solid #2F3E92'}}
      >
        <Flex
          justify="space-between"
          align="center"
          px={'16px'}
          py={'8px'}
          gap={'16px'}
          bg={selectedCategory === cat ? '#2F3E92' : '#F1ECD9'}
          borderTopRadius={'4px'}
          alignItems={'center'}
        >
          <Flex gap="2" alignItems={'center'}>
            {selectedCategory === cat && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              >
                <path
                  d="M11.4954 6.917L7.74545 11.5003L6.07878 9.83366M16.7038 9.00033C16.7038 13.2575 13.2526 16.7087 8.99545 16.7087C4.73825 16.7087 1.28711 13.2575 1.28711 9.00033C1.28711 4.74313 4.73825 1.29199 8.99545 1.29199C13.2526 1.29199 16.7038 4.74313 16.7038 9.00033Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            )}
            <Text
              fontSize={{ base: '16px', md: '18px' }}
              lineHeight={{ base: '22.4px', md: '27px' }}
              fontFamily="FedraSansStd-medium"
              color={selectedCategory === cat ? '#FFF' : '#1D1A16'}
              letterSpacing={{ base: '0.32px', md: '0.36px' }}
            >
              {cat}
            </Text>
          </Flex>
          <Text
            fontSize={{ base: '16px', md: '18px' }}
            lineHeight={{ base: '22.4px', md: '27px' }}
            fontFamily="FedraSansStd-medium"
            color={selectedCategory === cat ? '#FFF' : '#1D1A16'}
            letterSpacing={{ base: '0.32px', md: '0.36px' }}
          >
            {price}
          </Text>
        </Flex>
        <GetProgramFeatureList features={data?.features} />
        <Flex
          gap={4}
          py={3}
          px={4}
          borderTop={'1px solid rgba(29, 26, 22, 0.10)'}
          alignItems={'center'}
          bg="white"
          rounded={'0px 0px 4px 4px'}
        >
          {!!data?.dates?.length &&
            data?.dates?.map((d, i) => (
              <Flex key={i} alignItems={'center'} gap={1}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      d="M8.75359 5.54134L6.12858 8.74968L4.96192 7.58301M12.5453 6.99968C12.5453 10.0603 10.0642 12.5414 7.00359 12.5414C3.943 12.5414 1.46191 10.0603 1.46191 6.99968C1.46191 3.9391 3.943 1.45801 7.00359 1.45801C10.0642 1.45801 12.5453 3.9391 12.5453 6.99968Z"
                      stroke="#329E0E"
                      stroke-width="1.5"
                      stroke-linecap="square"
                    />
                  </svg>
                {/* {i === 0 ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      d="M8.75359 5.54134L6.12858 8.74968L4.96192 7.58301M12.5453 6.99968C12.5453 10.0603 10.0642 12.5414 7.00359 12.5414C3.943 12.5414 1.46191 10.0603 1.46191 6.99968C1.46191 3.9391 3.943 1.45801 7.00359 1.45801C10.0642 1.45801 12.5453 3.9391 12.5453 6.99968Z"
                      stroke="#329E0E"
                      stroke-width="1.5"
                      stroke-linecap="square"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      d="M10.9221 3.08113C9.91929 2.07828 8.53388 1.45801 7.00359 1.45801C3.943 1.45801 1.46191 3.9391 1.46191 6.99968C1.46191 8.52997 2.08219 9.91539 3.08503 10.9182M10.9221 3.08113C11.925 4.08397 12.5453 5.46939 12.5453 6.99968C12.5453 10.0603 10.0642 12.5414 7.00359 12.5414C5.4733 12.5414 4.08788 11.9211 3.08503 10.9182M10.9221 3.08113L3.08503 10.9182"
                      stroke="#1D1A16"
                      stroke-opacity="0.5"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </svg>
                )} */}
                <Text
                  // color={
                  //   i === 0 ? 'rgba(0, 0, 0, 0.92)' : 'rgba(29, 26, 22, 0.50)'
                  // }
                  color={
                    'rgba(0, 0, 0, 0.92)'
                  }
                  fontSize={'10px'}
                  lineHeight={'14px'}
                  fontFamily="FedraSansStd-book"
                >
                  {formatDateRange(d?.start, d?.end)}
                </Text>{' '}
              </Flex>
            ))}
        </Flex>
      </Box>
    );
  };

  const cardDetails = (title, value) => {
    return (
      <Text
        fontSize={{ base: '14px', md: '16px' }}
        lineHeight={'21px'}
        letterSpacing={{ base: '0.28px', md: '0.32px' }}
        fontFamily="FedraSansStd-book"
        color={'#1D1A16'}
        borderLeft={'2px solid #CF4520'}
        pl="8px"
      >
        {title}{' '}
        <Text as={'span'} fontWeight={'bold'}>
          {value}
        </Text>
      </Text>
    );
  };

  const getCurrentStepText = (option1, option2, options3) => {
    switch (currentStep) {
      case 1:
        return option1;
      case 2:
        return option2;
      case 3:
        return options3;
      default:
        return '';
    }
  };

  const FooterButtonClick = () => {
    if (isButtonDisabled) return;

    if (currentStep === 1) {
      mixPanelTrigger();
    }
    if (currentStep === 2) {
      mixPanelBatchEventFire();
    }
    if (currentStep === 3) {
      onRegisterClick();
      return;
    }
    setCurrentStep(currentStep + 1);
  };

  const isSameDate = (data1, data2) => {
    const date1 = `${data1?.start}/${data1?.end}`;
    const date2 = `${data2?.start}/${data2?.end}`;
    return date1 === date2;
  };

  const onDurationUpdate = value => {
    setSelectedDuration(value);
    setSelectedDateObj({});
    setSelectedCategory('');
  };

  const getFooterButton = () => {
    return (
      <Button
        id={'continutBtnReg'}
        display={'flex'}
        fontSize={"20px"}
        lineHeight={'22.4px'}
        w={'full'}
        textAlign={'center'}
        py={4}
        fontWeight={'bold'}
        color={
          isButtonDisabled
            ? 'rgba(29, 26, 22, 0.40)'
            : currentStep === 3
            ? '#fff'
            : '#CF4520'
        }
        gap={4}
        borderRadius={'0px'}
        border={'none'}
        minH={'54px'}
        mx={'auto'}
        _hover={{
          background: currentStep === 3 ? '#CF4520' : !isButtonDisabled ? '#AB3312' : '#fff',
          border: 'none',
          color: isButtonDisabled
            ? 'rgba(29, 26, 22, 0.40)'
            : currentStep === 3
            ? '#fff'
            : '#fff',
        }}
        onClick={FooterButtonClick}
        cursor={isButtonDisabled ? 'not-allowed' : 'pointer'}
        disabled={isButtonDisabled}
        bg={currentStep === 3 ? '#CF4520' : '#fff'}
        textTransform={'uppercase'}
        letterSpacing={'2.56px'}
        fontFamily="'Fedra Sans Alt Pro', sans-serif"
      >
        <Box
          justifyContent={'center'}
          display="flex"
          alignItems="center"
          gap="8px"
          height={'34px'}
        >
          <Box
            className="allSmallCase"
            lineHeight={'20px'}
            paddingBottom={'6px'}
          >
            {getCurrentStepText(continueText, continue2Text, continue3Text)}
          </Box>
          <Box>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
            >
              <path className="arrowPath"
                d="M10.5 4.31299L15.1875 9.00048M15.1875 9.00048L10.5 13.688M15.1875 9.00048H2.81249"
                stroke={
                  isButtonDisabled
                    ? '#1D1A16'
                    : currentStep === 3
                    ? '#fff'
                    : '#CF4520'
                }
                stroke-opacity={isButtonDisabled ? '0.4' : '1'}
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Box>
          {!isButtonDisabled ? 
          <style>
            {`#continutBtnReg:hover .arrowPath {stroke: #fff !important}`}
          </style>
          : null}
        </Box>
      </Button>
    );
  };

  const mixPanelBatchEventFire = () => {
    Mixpanel.track('margazhi_batch_selected', {
      duration: selectedDuration,
      batch: formatDateRange(
        selectedDateObj?.start,
        selectedDateObj?.end,
        true
      ),
      category: selectedCategory,
      amount: getPrice(currentSelectedProgram?.price, selectedCategory),
    });
  };

  const onBatchSelect = data => {
    setSelectedDateObj(data);
  };

  const getColor = tagName => {
    switch (tagName) {
      case 'popular':
        return { bg: '#2F3E92', color: '#fff' };
      case 'filling fast':
        return { bg: '#FFBF47', color: '#1D1A16' };
      case 'sold out':
        return { bg: '#F2F2F2', color: '#6F6E6C' };
      default:
        return {};
    }
  };

  const getDurationDates = (date, index) => {
    const tagName = currentSelectedProgram?.tag?.toLowerCase();
    const isSoldOut = tagName === 'sold out';
    const isDateSame = isSameDate(date, selectedDateObj);
    const bgColor = isSoldOut ? '#DFDFDF' : isDateSame ? '#2F3E92' : '#fff';
    const textColor = isSoldOut
      ? 'rgba(29, 26, 22, 0.60)'
      : isDateSame
      ? '#fff'
      : '#1D1A16';
    return (
      <Box
        key={index}
        position={'relative'}
        py={'24px'}
        px={'32px'}
        bg={bgColor}
        outline={
          isDateSame || isSoldOut ? 'none' : '1px solid rgba(29, 26, 22, 0.10)'
        }
        borderRadius={'4px'}
        boxShadow={
          '0 29px 8px 0 rgba(0, 0, 0, 0.00), 0 18px 7px 0 rgba(0, 0, 0, 0.00), 0 10px 6px 0 rgba(0, 0, 0, 0.01), 0 5px 5px 0 rgba(0, 0, 0, 0.02), 0 1px 3px 0 rgba(0, 0, 0, 0.02)'
        }
        cursor={isSoldOut ? 'not-allowed' : 'pointer'}
        onClick={() => !isSoldOut && onBatchSelect(date)}
        overflow={'hidden'}
        border={'1px solid transparent'}
        _hover={{
          border: '1px solid #2F3E92'
        }}
      >
        <Text
          fontSize={{ base: '14px', md: '18px' }}
          lineHeight={{ base: '16.8px', md: '27px' }}
          color={textColor}
          fontFamily={isDateSame ? 'FedraSansStd-medium' : 'FedraSansStd-book'}
          letterSpacing={{ base: '0.28px', md: '0.36px' }}
        >
          {formatDateRange(date?.start, date?.end, true)}
        </Text>
        {tagName && (
          <Box
            borderRadius={'4px'}
            top="-1px"
            right="-1px"
            position={'absolute'}
            fontFamily="FedraSansStd-book"
            bg={getColor(tagName)?.bg}
            p={'2px 8px 6px 8px'}
            fontSize={'16px'}
            lineHeight={'14.4px'}
            color={getColor(tagName)?.color}
            textTransform={'uppercase'}
            className="allSmallCase"
            zIndex={'1'}
          >
            {tagName}
          </Box>
        )}
      </Box>
    );
  };

  return (
    <>
      {isMounted && (
        <>
          <ParentModal isOpen={true}>
            <ParentModalContent>
              <Box
                display={isLargeScreen ? 'none' : { base: 'none', md: 'block' }}
                width={{ md: '100vw' }}
                bgColor={!isLargeScreen ? '#00000080' : '#1D1A16CC'}
                position={'fixed'}
                left={0}
                top={0}
                zIndex={1000}
                height={'100vh'}
                pointerEvents="auto"
                sx={{
                  touchAction: 'none',
                  overscrollBehavior: 'none',
                }}
                onTouchStart={e => e.preventDefault()}
                onTouchMove={e => e.preventDefault()}
                onClick={e => e.preventDefault()}
                animation={{
                  base: `${isOpen ? fadeIn : fadeOut} 0.5s ease-out forwards`,
                  md: `${isOpen ? fadeIn : fadeOut} 0.5s ease-out forwards`,
                }}
              />
              <Box
                overflowY={'auto'}
                animation={{
                  base: `${isOpen ? slideUp : slideDown} 0.5s ease-out forwards`,
                  md: `${isOpen ? slideIn : slideOut} 0.5s ease-out forwards`,
                }}
                position={'fixed'}
                height={'100%'}
                maxH={'100%'}
                top={0}
                right={0}
                bgColor={'#fff'}
                width={{ base: '100%', md: '410px' }}
                zIndex={1001}
                id="register-popup"
              >
                <Grid
                  templateRows="max-content max-content max-content 1fr max-content"
                  h={'full'}
                  overflow={'hidden'}
                >
                  <Flex
                    justify="space-between"
                    align="center"
                    pb={'8px'}
                    px={'16px'}
                    pt={'16px'}
                  >
                    <Box cursor={'pointer'} onClick={onBackClick}>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.50001 13.6875L2.8125 9.00001M2.8125 9.00001L7.50001 4.31249M2.8125 9.00001H15.1875"
                          stroke="black"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Box>
                    <Box cursor={'pointer'} onClick={onCloseHandler}>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.75 3.75L14.25 14.25M14.25 3.75L3.75 14.25"
                          stroke="black"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                      </svg>
                    </Box>
                  </Flex>
                  <Grid
                    pt="16px"
                    alignItems="center"
                    gap={4}
                    templateColumns="max-content 1fr"
                    pb={{ base: '8px', md: '10px' }}
                    px={'16px'}
                    borderBottom={'1px solid rgba(29, 26, 22, 0.10)'}
                    bg="white"
                  >
                    <Text
                      fontSize={'14px'}
                      lineHeight={'16.8px'}
                      fontFamily="FedraSansStd-medium"
                      color={'#1D1A16'}
                    >
                      {getCurrentStepText(step1, step2, step3)}
                    </Text>
                    <Grid
                      alignItems="center"
                      gap={'2px'}
                      templateColumns="1fr 1fr 1fr"
                    >
                      {totalStep.map((step, index) => (
                        <Grid
                          gap={'2px'}
                          templateColumns="1fr max-content"
                          alignItems="center"
                          key={index}
                          w={'full'}
                        >
                          <Box
                            border={
                              step <= currentStep
                                ? '1px solid #329E0E'
                                : '1px solid #1d1a1633'
                            }
                            borderRadius={
                              step === 1 ? '8px 0px 0px 8px' : '0px 8px 8px 0px'
                            }
                          ></Box>
                          {step < currentStep ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M7.33171 13.6668C11.0136 13.6668 13.9984 10.6821 13.9984 7.00016C13.9984 3.31827 11.0136 0.333496 7.33171 0.333496C3.64981 0.333496 0.665039 3.31827 0.665039 7.00016C0.665039 10.6821 3.64981 13.6668 7.33171 13.6668ZM6.3813 9.99244L10.2699 5.23966L9.238 4.39535L6.28232 8.00784L4.99847 6.724L4.05567 7.66681L6.3813 9.99244Z"
                                fill="#329E0E"
                              />
                            </svg>
                          ) : (
                            <Box
                              w={currentStep === step ? '16px' : '12px'}
                              h={currentStep === step ? '16px' : '12px'}
                              border={
                                currentStep === step
                                  ? '2px solid #329E0E'
                                  : '2px solid #1d1a1633'
                              }
                              bg={currentStep === step ? '#329E0E' : 'transparent'}
                              borderRadius={'50%'}
                            ></Box>
                          )}
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>

                  <Grid
                    gap={2}
                    boxShadow={
                      '0 29px 8px 0 rgba(0, 0, 0, 0.00), 0 18px 7px 0 rgba(0, 0, 0, 0.00), 0 10px 6px 0 rgba(0, 0, 0, 0.01), 0 5px 5px 0 rgba(0, 0, 0, 0.02), 0 1px 3px 0 rgba(0, 0, 0, 0.02)'
                    }
                    bg="white"
                    zIndex={'1'}
                  >
                    <Text
                      fontSize={'18px'}
                      lineHeight={'16.8px'}
                      fontFamily="FedraSansStd-medium"
                      color={'rgba(29, 26, 22, 0.70)'}
                      letterSpacing={{ base: '0.28px', md: '1.28px' }}
                      textTransform={'uppercase'}
                      pt="20px"
                      px={'16px'}
                      pb="4px"
                      className="allSmallCase"
                    >
                      {getCurrentStepText(
                        duration1Text,
                        selection2Text,
                        selection3Text
                      )}
                    </Text>
                    {currentStep === 1 && (
                      <Flex
                        justifyContent={'space-between'}
                        px={'16px'}
                        pb={'24px'}
                      >
                        {durations.map(d => {
                          const isDataAvailable = !!Object.keys(
                            duration?.[d]?.categories
                          )?.length;
                          return (
                            <Box
                              key={d}
                              w={{ base: '60.8px', md: '70.8px' }}
                              h={{ base: '35px', md: '38px' }}
                              display={'flex'}
                              justifyContent={'center'}
                              alignItems={'center'}
                              fontSize={'16px'}
                              fontFamily={
                                selectedDuration === d
                                  ? 'FedraSansStd-medium'
                                  : 'FedraSansStd-book'
                              }
                              letterSpacing={'0.32px'}
                              color={
                                !isDataAvailable
                                  ? '#1d1a1699'
                                  : selectedDuration === d
                                    ? '#FFFFFF'
                                    : '#1D1A16'
                              }
                              border={
                                !isDataAvailable
                                  ? 'none'
                                  : selectedDuration === d
                                    ? '1px solid #2F3E92'
                                    : '1px solid rgba(29, 26, 22, 0.10)'
                              }
                              bg={
                                !isDataAvailable
                                  ? '#DFDFDF'
                                  : selectedDuration === d
                                    ? '#2F3E92'
                                    : 'transparent'
                              }
                              onClick={() => isDataAvailable && onDurationUpdate(d)}
                              cursor={!isDataAvailable ? 'not-allowed' : 'pointer'}
                              boxShadow={
                                '0 29px 8px 0 rgba(0, 0, 0, 0.00), 0 18px 7px 0 rgba(0, 0, 0, 0.00), 0 10px 6px 0 rgba(0, 0, 0, 0.01), 0 5px 5px 0 rgba(0, 0, 0, 0.02), 0 1px 3px 0 rgba(0, 0, 0, 0.02)'
                              }
                              borderRadius={'4px'}
                              _hover={{
                                border: '1px solid #2F3E92'
                              }}
                            >
                              {d}
                            </Box>
                          );
                        })}
                      </Flex>
                    )}
                    {currentStep === 2 && (
                      <Flex
                        justifyContent={'space-between'}
                        gap={'24px'}
                        alignItems={'center'}
                        px={'16px'}
                        pb={'24px'}
                        pt={'8px'}
                      >
                        <Flex gap={'24px'} alignItems={'center'}>
                          {cardDetails(durationText, `${selectedDuration} days`)}
                          {cardDetails(categoryText, selectedCategory)}
                        </Flex>
                        <Box mt={'-10px'} height='37px'
                          width='37px' display={'flex'}
                          justifyContent={'center'}
                          alignItems={'center'}
                          _hover={{
                            background: '#1D1A160D',
                            borderRadius: '100%'
                          }}
                          cursor={'pointer'} onClick={() => setCurrentStep(1)}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="21"
                            height="21"
                            viewBox="0 0 21 21"
                            fill="none"
                          >
                            <path
                              d="M11.1562 7.21875L10.6922 6.75471C10.5691 6.87778 10.5 7.0447 10.5 7.21875H11.1562ZM11.1562 9.84375H10.5C10.5 10.2062 10.7938 10.5 11.1562 10.5V9.84375ZM13.7812 9.84375V10.5C13.9553 10.5 14.1222 10.4309 14.2453 10.3078L13.7812 9.84375ZM16.4062 1.96875L16.8703 1.50471C16.614 1.24843 16.1985 1.24843 15.9422 1.50471L16.4062 1.96875ZM19.0312 4.59375L19.4953 5.05779C19.7516 4.80151 19.7516 4.38599 19.4953 4.12971L19.0312 4.59375ZM17.7188 17.7188V18.375C18.0812 18.375 18.375 18.0812 18.375 17.7188H17.7188ZM3.28125 17.7188H2.625C2.625 18.0812 2.91881 18.375 3.28125 18.375V17.7188ZM3.28125 3.28125V2.625C2.91881 2.625 2.625 2.91881 2.625 3.28125H3.28125ZM9.84375 3.9375C10.2062 3.9375 10.5 3.64369 10.5 3.28125C10.5 2.91881 10.2062 2.625 9.84375 2.625V3.28125V3.9375ZM18.375 11.1562C18.375 10.7938 18.0812 10.5 17.7188 10.5C17.3563 10.5 17.0625 10.7938 17.0625 11.1562H17.7188H18.375ZM11.1562 7.21875H10.5V9.84375H11.1562H11.8125V7.21875H11.1562ZM11.1562 9.84375V10.5H13.7812V9.84375V9.1875H11.1562V9.84375ZM11.1562 7.21875L11.6203 7.68279L16.8703 2.43279L16.4062 1.96875L15.9422 1.50471L10.6922 6.75471L11.1562 7.21875ZM16.4062 1.96875L15.9422 2.43279L18.5672 5.05779L19.0312 4.59375L19.4953 4.12971L16.8703 1.50471L16.4062 1.96875ZM19.0312 4.59375L18.5672 4.12971L13.3172 9.37971L13.7812 9.84375L14.2453 10.3078L19.4953 5.05779L19.0312 4.59375ZM17.7188 17.7188V17.0625H3.28125V17.7188V18.375H17.7188V17.7188ZM3.28125 17.7188H3.9375V3.28125H3.28125H2.625V17.7188H3.28125ZM3.28125 3.28125V3.9375H9.84375V3.28125V2.625H3.28125V3.28125ZM17.7188 11.1562H17.0625V17.7188H17.7188H18.375V11.1562H17.7188Z"
                              fill="#CF4520"
                            />
                          </svg>
                        </Box>
                      </Flex>
                    )}
                    {currentStep === 3 && (
                      <Box>
                        <Text
                          fontSize={'20px'}
                          lineHeight={'22.4px'}
                          fontFamily="FedraSansStd-medium"
                          color={'#2F3E92'}
                          fontWeight={'500'}
                          letterSpacing={'0.32px'}
                          textTransform={'uppercase'}
                          mt={'4px'}
                          mb={'12px'}
                          px={'16px'}
                          className="allSmallCase"
                        >
                          {year}
                        </Text>
                        <Box borderLeft={'2px solid #CF4520'} pl="8px" mx={'16px'}>
                          <Text
                            fontSize={{ base: '16px', md: '18px' }}
                            lineHeight={{ base: '10.4px', md: '22.8px' }}
                            letterSpacing={{ base: '1.92px', md: '2.24px' }}
                            fontFamily="FedraSansStd-book"
                            color={'rgba(29, 26, 22, 0.70)'}
                            textTransform={'uppercase'}
                            pb={'4px'}
                            className="allSmallCase"
                          >
                            {categoryText?.replace(':', '')}{' '}
                          </Text>
                          <Text
                            fontSize={{ base: '16px', md: '18px' }}
                            lineHeight={{ base: '22.4px', md: '27px' }}
                            letterSpacing={{ base: '0.32px', md: '0.36px' }}
                            fontFamily="FedraSansStd-medium"
                            color={'#1D1A16'}
                            mb={'12px'}
                          >
                            {selectedCategory}
                          </Text>
                          <Text
                            fontSize={{ base: '16px', md: '18px' }}
                            lineHeight={{ base: '10.4px', md: '22.8px' }}
                            letterSpacing={{ base: '1.92px', md: '2.24px' }}
                            fontFamily="FedraSansStd-book"
                            color={'rgba(29, 26, 22, 0.70)'}
                            mb={{ base: '5px', md: '0px' }}
                            textTransform={'uppercase'}
                            pb={'4px'}
                            className="allSmallCase"
                          >
                            {durationText?.replace(':', '')}
                          </Text>
                          <Text
                            fontSize={{ base: '16px', md: '18px' }}
                            lineHeight={{ base: '22.4px', md: '27px' }}
                            letterSpacing={{ base: '0.32px', md: '0.36px' }}
                            fontFamily="FedraSansStd-medium"
                            color={'#1D1A16'}
                          >
                            {formatDateRange(
                              selectedDateObj?.start,
                              selectedDateObj?.end,
                              true
                            )}
                          </Text>
                        </Box>
                        <Flex
                          pt={'24px'}
                          pb={'16px'}
                          gap={2}
                          flexWrap={'wrap'}
                          px={'16px'}
                        >
                          {currentSelectedProgram?.features?.map((data, i) => {
                            return (
                              <Flex
                                key={i}
                                gap={1}
                                align={'center'}
                                bg={'rgba(29, 26, 22, 0.05)'}
                                borderRadius={'24px'}
                                p={'8px 12px'}
                              >
                                <Image
                                  key={i}
                                  src={data?.image}
                                  alt={`img-${i}`}
                                  w="12px"
                                  h="12px"
                                  objectFit="contain"
                                  display="block"
                                />
                                <Text
                                  fontSize={{ base: '10px', md: '12px' }}
                                  lineHeight={{ base: '12px', md: '14px' }}
                                  w={'full'}
                                  fontFamily="FedraSansStd-book"
                                  textAlign={'center'}
                                >
                                  {data?.label}
                                </Text>
                              </Flex>
                            );
                          })}
                        </Flex>
                        <Flex
                          alignItems={'center'}
                          justifyContent={'space-between'}
                          p={'16px'}
                          border={'1px solid rgba(29, 26, 22, 0.10)'}
                        >
                          <Text
                            lineHeight={{ base: '16.8px', md: '22.4px' }}
                            fontFamily="FedraSansStd-book"
                            textAlign={'center'}
                            color={'rgba(29, 26, 22, 0.80)'}
                            fontSize={{ base: '14px', md: '16px' }}
                            letterSpacing={{ base: '0.28px', md: '0.32px' }}
                          >
                            {amount}
                          </Text>
                          <Text
                            lineHeight={{ base: '16.8px', md: '24px' }}
                            fontFamily="FedraSansStd-medium"
                            textAlign={'center'}
                            color={'#CF4520'}
                            fontSize={{ base: '18px', md: '20px' }}
                            letterSpacing={{ base: '-0.72px', md: '0.4px' }}
                          >
                            {getPrice(
                              currentSelectedProgram?.price,
                              selectedCategory
                            )}
                          </Text>
                        </Flex>
                      </Box>
                    )}
                  </Grid>

                  <Box
                    ref={scrollableContentRef}
                    bg={'#f5f5f5'}
                    px={'16px'}
                    py={{ base: '24px', md: '32px' }}
                    overflow={'auto'}
                  >
                    <Text
                      fontSize={'18px'}
                      lineHeight={'16.8px'}
                      fontFamily="FedraSansStd-medium"
                      color={'rgba(29, 26, 22, 0.70)'}
                      letterSpacing={{ base: '0.28px', md: '1.28px' }}
                      textTransform={'uppercase'}
                      className="allSmallCase"
                      pb="4px"
                    >
                      {getCurrentStepText(category, batch2Text, batch3Text)}
                    </Text>
                    {currentStep === 1 && (
                      <Flex pt={'8px'} gap={'12px'} flexDirection={'column'}>
                        {currentSelectedDurationData.map(cat => getData(cat))}
                      </Flex>
                    )}
                    {currentStep === 2 && (
                      <Flex pt={'8px'} gap={'12px'} flexDirection={'column'}>
                        {currentSelectedProgram?.dates?.map((date, index) =>
                          getDurationDates(date, index)
                        )}
                      </Flex>
                    )}
                    {currentStep === 3 && (
                      <Flex flexDirection={'column'} gap={4} py={4}>
                        {testimonialData?.testimonials?.map((item, index) => (
                          <Box
                            maxW="full"
                            border="1px solid 1px solid rgba(0, 0, 0, 0.06)"
                            borderRadius="4px"
                            p={3}
                            bg="white"
                            key={index}
                          >
                            <Flex align="center" mb={4}>
                              <Image
                                src={item?.photo?.url}
                                alt={item?.userName}
                                w="32px"
                                h="32px"
                                objectFit="contain"
                                display="block"
                                loading="lazy"
                                mr={2}
                              />
                              <VStack align="start" spacing={1}>
                                <Text
                                  fontSize={'16px'}
                                  lineHeight={'17.6px'}
                                  fontFamily="FedraSansStd-medium"
                                  color={'rgba(29, 26, 22, 0.80)'}
                                  letterSpacing={'0.32px'}
                                >
                                  {item?.userName}
                                </Text>

                                <StructuredTextParser
                                  str={render(item?.userDescription)}
                                  fontSize={'16px'}
                                  lineHeight={'15.2px'}
                                  fontFamily="FedraSansStd-book"
                                  color={'#CF4520'}
                                  letterSpacing={'1.92px'}
                                  textTransform={'uppercase'}
                                  mt="0"
                                  fontWeight={'450'}
                                  pb="4px"
                                  className="allSmallCase"
                                />
                              </VStack>
                            </Flex>

                            <StructuredTextParser
                              str={render(item?.testimonialText)}
                              fontSize={'12px'}
                              lineHeight={'19.2px'}
                              fontFamily="FedraSansStd-book"
                              color={'#1D1A16'}
                              letterSpacing={'0.24px'}
                              mt="0"
                            />
                          </Box>
                        ))}
                      </Flex>
                    )}
                  </Box>
                  <Box className="register-footer-btn">
                    {currentStep !== 3 ? (
                      getFooterButton()
                    ) : (
                      <Link href={selectedDateObj?.link || ''}>
                        {getFooterButton()}
                      </Link>
                    )}
                  </Box>
                </Grid>
                <style jsx global>
                  {`
                .register-footer-btn button {
                  box-shadow: 0 -22px 6px 0 rgba(0, 0, 0, 0),
                    0 -14px 6px 0 rgba(0, 0, 0, 0.01),
                    0 -8px 5px 0 rgba(0, 0, 0, 0.02),
                    0 -4px 4px 0 rgba(0, 0, 0, 0.04),
                    0 -1px 2px 0 rgba(0, 0, 0, 0.04);
                }
                .allSmallCase {
                  font-variant: all-small-caps;
                }
              `}
                </style>
              </Box>
            </ParentModalContent>
          </ParentModal>
        </>
      )}
    </>
  );
}
